import "./Card.css";
import ctf from "./ctf.jpeg";

function Card() {
    return (
      <div className="Activitiescardcss">
        <img className="ActImage" src={ctf} alt={""}></img>
      </div>
    );
  }
  
export default Card;